// extracted by mini-css-extract-plugin
export var standaloneTable = "_im-0";
export var standaloneTableWithBodyFill = "_im-1";
export var withExtraHeader = "_im-2";